import { render, staticRenderFns } from "./relacionarOficio.vue?vue&type=template&id=52b9ad80"
import script from "./relacionarOficio.vue?vue&type=script&lang=js"
export * from "./relacionarOficio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports